module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "changelogModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.changelog), function(content, version) {
    return _c('div', {
      key: version
    }, [(
      version === 'dev' && ['dev', 'training', 'dev-audi', 'training-audi'].indexOf(
        _vm.feature.currentTarget
      ) > -1
    ) ? [_c('span', {
      staticClass: "version-number"
    }, [_vm._v("In Progress")]), _vm._v(" "), _vm._l((content.changes), function(entry, index) {
      return _c('div', {
        key: index,
        staticClass: "change-entry"
      }, [_vm._v("\n              ● " + _vm._s(entry) + "\n            ")])
    }), _vm._v(" "), _c('hr')] : _vm._e(), _vm._v(" "), (version !== 'dev') ? [_c('span', {
      staticClass: "version-number"
    }, [_vm._v("v" + _vm._s(version))]), _vm._v(" "), _c('span', {
      staticClass: "version-date"
    }, [_vm._v("(" + _vm._s(content.date) + ")")]), _vm._v(" "), _vm._l((content.changes), function(entry, index) {
      return _c('div', {
        key: index,
        staticClass: "change-entry"
      }, [_vm._v("\n              ● " + _vm._s(entry) + "\n            ")])
    }), _vm._v(" "), _c('hr')] : _vm._e()], 2)
  }), 0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Changelog")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Close\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81acb4da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/ChangelogModal.vue
// module id = 1706
// module chunks = 1